import { useQueries } from '@tanstack/react-query';
import { useFormContext } from 'react-hook-form';
import { SearchableSelect } from '../../../components/SearchableSelect';
import { adminApi } from '../adminApi';
import { useCatalogCategoryOptions } from './useCatalogCategoryOptions';

export function CatalogProductCategoriesSelect({ value, onChange, error }: { value: string[]; onChange: (value: string[]) => void; error?: string }) {
  const { formState } = useFormContext();
  const categories = useCatalogCategoryOptions('');
  const selected = useQueries({ queries: value.map((id) => ({ queryKey: ['catalog', 'category', id], queryFn: () => adminApi.getCatalogCategories({ category_id: Number(id), page: 1, per_page: 1 }) })) });
  const options = [...categories.options];
  for (const query of selected) {
    const category = query.data?.items[0];
    if (category && !options.some((option) => option.value === String(category.category_id))) options.push({ value: String(category.category_id), label: category.category_name });
  }
  return <><SearchableSelect inputId="product_category_ids" ariaLabel="Дополнительные категории" isMulti isClearable isDisabled={formState.isSubmitting} value={value} onChange={onChange} options={options} onSearchChange={categories.setSearch} placeholder="Выберите категории" ariaInvalid={Boolean(error)} />{categories.error || selected.some((query) => query.isError) ? <span role="alert">Не удалось загрузить категории. Повторите поиск.</span> : null}</>;
}
